export default __webpack_public_path__ + "static/media/search.d10a91a8.svg";